// src/components/WhatsAppButton.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
    const handleClick = () => {
        window.open('https://wa.me/+917558340139', '_blank'); // Replace with your WhatsApp number
    };

    return (
        <div className="whatsapp-capsule" onClick={handleClick}>
            <FontAwesomeIcon icon={faWhatsapp} size="1x" className="whatsapp-icon" />
            <span className="whatsapp-text">WhatsApp Us</span>
        </div>
    );
};

export default WhatsAppButton;
